import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Barcode } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email.trim(), password);
    setLoading(false);
    if (res.ok) navigate("/");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2.5 mb-8">
          <div className="w-9 h-9 rounded-md bg-red-900 flex items-center justify-center">
            <Barcode size={18} className="text-white" />
          </div>
          <div>
            <div className="text-[17px] font-semibold tracking-tight text-zinc-950 leading-none">
              Custom Barcode Generator
            </div>
            <div className="text-[11px] text-zinc-500 mt-1">MRP Label &amp; Barcode Studio</div>
          </div>
        </div>

        <h1 className="text-2xl font-semibold tracking-tight text-zinc-950 mb-1">Sign in</h1>
        <p className="text-sm text-zinc-500 mb-6">Access your saved products and print queue.</p>

        <form onSubmit={onSubmit} className="space-y-4" data-testid="login-form">
          <div className="space-y-1.5">
            <Label htmlFor="email" className="text-[12px] font-medium text-zinc-700">Email</Label>
            <Input
              id="email"
              type="email"
              data-testid="login-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="admin@barcodegen.app"
              className="h-10"
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password" className="text-[12px] font-medium text-zinc-700">Password</Label>
            <Input
              id="password"
              type="password"
              data-testid="login-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
              className="h-10"
            />
          </div>
          {error && (
            <div
              data-testid="login-error"
              className="text-[12px] text-red-700 bg-red-50 border border-red-200 px-3 py-2 rounded-md"
            >
              {error}
            </div>
          )}
          <Button
            type="submit"
            disabled={loading}
            data-testid="login-submit-btn"
            className="w-full h-10 bg-zinc-950 text-white hover:bg-zinc-800 transition-colors"
          >
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>

        <div className="mt-6 text-[11px] text-zinc-500 text-center">
          Access is by invitation only. Ask your admin for an account.
        </div>
      </div>
    </div>
  );
}
